<div class="min-w-16 bg-gray-200 rounded-full h-2">
    <div class="h-2 rounded-full transition-all duration-300 ease-in-out" [ngClass]="{
      'bg-red-500': progress < lowPercent,
      'bg-green-500': progress >= lowPercent
    }" [style.width.%]="progress"></div>
</div>
<p class="text-xs text-gray-600 mt-1 font-light text-right">{{ progress }}%</p>